import React from 'react'

const NoScreen = () => {
  return <div>NoScreen</div>
}

export default NoScreen
